<template>
  <div v-if="data.type == 'text'">
    <text-component :data="data.text"></text-component>
  </div>

  <div v-if="data.type == 'checkbox'">
    <Checkbox :data="data" @formModEvent="emitChildEvent" :baseValue="result" :key="`${selectedTask}.${data.text}`"></Checkbox>
  </div>
  
  <div v-if="data.type == 'multiCheckbox'">
    <MultiCheckbox :data="data" @formModEvent="emitChildEvent" :baseValue="result" :key="`${selectedTask}.${data.text}`"></MultiCheckbox>
  </div>

  <div v-if="data.type == 'img'">
    <image-component :data="data.imgSrc"></image-component>
  </div>

  <div v-if="data.type == 'textbox'">
    <TextBox :data="data" @formModEvent="emitChildEvent" :baseValue="result" :key="`${selectedTask}.${data.text}`"></TextBox>
  </div>

  <div v-if="data.type == 'multiTextBox'">
    <MultiTextbox :data="data" @formModEvent="emitChildEvent" :baseValue="result" :key="`${selectedTask}.${data.text}`"></MultiTextbox>
  </div>

  <div v-if="data.type == 'checkboxWithText'">
    <CheckboxWithTextComponent :data="data" @formModEvent="emitChildEvent" :baseValue="result" :key="`${selectedTask}.${data.text}`"></CheckboxWithTextComponent>
  </div>

  <div v-if="data.type == 'md'">
    <m-d :data="data.text"></m-d>
  </div>

  <div v-if="data.type == 'largeText'">
    <LargeTextComponent  :data="data" @formModEvent="emitChildEvent" :baseValue="result"></LargeTextComponent>
  </div>

  <div v-if="data.type == 'institute'">
    <InstituteComponent  :data="data" @formModEvent="emitChildEvent" :baseValue="result"></InstituteComponent>
  </div>

</template>

<script>
import { defineComponent } from 'vue'
import TextComponent from './Text.vue'
import Checkbox from './Checkbox.vue'
import MultiCheckbox from './MultiCheckbox.vue'
import ImageComponent from './Image.vue'
import TextBox from './TextBox.vue'
import MD from './MD.vue'
import MultiTextbox from './MultiTextBox.vue'
import CheckboxWithTextComponent from './CheckboxWithText.vue'
import LargeTextComponent from './LargeText.vue'
import InstituteComponent from './InstituteComponent.vue'

export default defineComponent({
    name: 'ComponentProvider',
    components: {
      TextComponent,
      Checkbox,
      MultiCheckbox,
      ImageComponent,
      TextBox,
      MD,
      MultiTextbox,
      CheckboxWithTextComponent,
      LargeTextComponent,
      InstituteComponent,
    },
    emits: ['formModEvent'],
    props: {
      data: Object,
      result: [Object, String, Boolean],
      selectedTask: Number,
    },
    methods: {
        emitChildEvent(data) {
        // Forward the event to the grandparent component
            this.$emit('formModEvent', data);
        }
    }
})
</script>